import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

interface Auth0PageProps {
  onUpdate?: () => void;
}

function Auth0Page({ onUpdate }: Auth0PageProps) {
  const navigate = useNavigate();
  const [message, setMessage] = useState('Completing login, please wait...');
  const { isLoading, isAuthenticated } = useAuth0();
  const hasHandledRef = useRef(false);

  useEffect(() => {
    console.log("Auth0Page: Processing login");
    
    const completeLogin = async () => {
      try {
        if (hasHandledRef.current) return;
        if (isLoading) {
          setMessage('Finishing sign-in...');
          return;
        }
        hasHandledRef.current = true;
        // Call onUpdate if provided
        if (onUpdate) {
          await onUpdate();
        }
        
        // Get the return URL from sessionStorage, or default to '/'
        let returnTo = sessionStorage.getItem('loginReturnUrl') || '/';
        // Never redirect back to the Auth0 callback route
        if (returnTo.startsWith('/auth0')) {
          returnTo = '/';
        }
        console.log(`Auth0Page: Will redirect to ${returnTo}`);
        
        // Clear the stored return URL before redirecting
        sessionStorage.removeItem('loginReturnUrl');
        
        // Update message and redirect
        setMessage('Login completed. Redirecting...');
        navigate(returnTo, { replace: true });
      } catch (error) {
        console.error('Auth0Page: Error during login completion:', error);
        setMessage('Login failed. Redirecting to home...');
        navigate('/', { replace: true });
      }
    };

    completeLogin();
  }, [navigate, onUpdate, isLoading, isAuthenticated]);

  return (
    <div className="page">
      <div className="dialog-cover">
        <div className="dialog-panel" style={{maxWidth: '250px', padding: '20px'}}>
          {message}
        </div>
      </div>
    </div>
  );
}

export default Auth0Page;